<template>
    <div class="animated fadeIn">
        <v-server-table :url="apiurl('report/table')"  :columns="columns" :options="options" :theme="theme" id="reportsTable" ref="reportsTable"  >
            <span slot="date_create_iso" slot-scope="props">
                {{ printDateTime(props.row.date_create_iso) }}
            </span>
            <span slot="id" slot-scope="props">
                <a :href="props.row.t_url" target="_blank">{{props.row.id}}</a>
            </span>
            <span slot="title" slot-scope="props">
                <a :href="props.row.t_url" target="_blank">{{props.row.title}}</a>
            </span>
        </v-server-table>
        WID=c1392ce0-4046-4085-be72-3140a24da1a9
    </div>
</template>

<script>
    import Vue from 'vue'
    import {ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions.js';
    Vue.use(ServerTable)
    import {CONSTANTS} from '@/constants';

    export default {
        name: 'NsbReports',
        components: { ServerTable, Event },
        mixins: [functions],
        data: function () {
            return {
                options: {
                    saveState: true,
                },
                columns: ['id', 'date_create_iso', 'title'],
                theme: {}
            }
        },
        methods: {

        },
        computed: {

        },
        created: function() {
            Event.$on('vue-tables.loading', ()=>{ /* this.$eventHub.$emit('loading_start'); */ });
            Event.$on('vue-tables.loaded',()=>{ /*this.$eventHub.$emit('loading_end'); */ });
        }
    }
</script>
